import { reloadApp } from '@/utils/app-reload';

const PRELOAD_RELOAD_KEY = 'gaia:preload-error-reload';

/** A second failure within this window means reloading didn't help; let the error surface. */
const RETRY_WINDOW_MS = 30_000;

/**
 * Reloads once when a lazily loaded chunk fails to load.
 *
 * Another tab can switch the UI build (Labs, `?branch=`) by changing the shared branch cookie.
 * This tab keeps running the old build, so its next lazy chunk is requested from the new branch
 * and 404s. Reloading picks up the build the cookie now selects. A failure soon after such a
 * reload (e.g. a genuinely missing chunk) is left to the app's error handling instead of looping.
 */
export function installPreloadErrorReload(): void {
  window.addEventListener('vite:preloadError', (event) => {
    let lastReload = 0;
    try {
      lastReload = Number(sessionStorage.getItem(PRELOAD_RELOAD_KEY)) || 0;
    } catch {
      // Storage unavailable: without a guard, don't risk a reload loop.
      return;
    }
    if (Date.now() - lastReload < RETRY_WINDOW_MS) return;
    try {
      sessionStorage.setItem(PRELOAD_RELOAD_KEY, String(Date.now()));
    } catch {
      return;
    }
    event.preventDefault();
    reloadApp();
  });
}
